$(function () {
  const $countrySwitcherModal = $('.country-switcher__modal');
  const $countrySwitcherBackdrop = $('.country-switcher__modal__backdrop');
  const $countrySwitcherClose = $('.country-switcher__modal__close');
  const toggleCountrySwitcher = function() {
    if ($countrySwitcherModal.hasClass('open')) {
      $('html').css('overflow-y', '');
    } else {
      $('html').css('overflow-y', 'hidden');
    }
    $countrySwitcherModal.toggleClass('open');
    $countrySwitcherBackdrop.toggleClass('open');
  };

  $countrySwitcherClose.on('mousedown', function() {
    toggleCountrySwitcher();
  });

  $countrySwitcherBackdrop.on('mousedown', function() {
    toggleCountrySwitcher();
  });


  $(".country-switcher").each(function () {
    const $countrySwitcher = $(this);
    const $activeCountry = $countrySwitcher.find(".country-switcher__active-country");

    if ($activeCountry.length > 0 && $countrySwitcherModal.length > 0) {
      $activeCountry.on("click", function (e) {
        toggleCountrySwitcher();
      });
    }
  });
});
